import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function FixTab() {
    const { useLang, useState, useEffect } = useGlobal();
    const { t } = useLang('communitylang');
    const [activeTab, setActiveTab] = useState(0);
    const tabs: any = [
        { text: t('fix_tab1'), id: '#community-page-B', key: 0 },
        { text: t('fix_tab2'), id: '#community-page-C', key: 1 },
        { text: t('fix_tab3'), id: '#community-page-D', key: 2 },
        { text: t('fix_tab4'), id: '#community-page-E', key: 3 },
    ];
    const handleClickTab = (k: number) => {
        setActiveTab(k);
    };

    let originX = 0,
        startX = 0;
    const onTouchStart = (e: any) => {
        originX = parseFloat(e.currentTarget?.style.left) || 0;
        startX = e.targetTouches[0]?.clientX;
    };

    const onTouchMove = (e: any) => {
        const moveX = e.targetTouches[0]?.clientX;
        const endX = originX + moveX - startX;
        if (endX <= 0 && endX >= window.innerWidth - e.currentTarget.offsetWidth) {
            e.currentTarget.style.left = `${endX}px`;
        }
    };

    useEffect(() => {
        const resizeFunc = () => {
            const target = document.querySelector('.community-page-fix-tab .tabs-box') as HTMLUListElement;
            target.style.transition = 'left .4s ease';
            if (target.offsetWidth > window.innerWidth && activeTab >= 3) {
                target.style.left = `${window.innerWidth - target.offsetWidth}px`;
            } else {
                target.style.left = `${0}px`;
            }
            setTimeout(() => {
                target.style.transition = 'none';
            }, 400);
        };
        resizeFunc();
        window.addEventListener('resize', resizeFunc);
        return () => window.removeEventListener('resize', resizeFunc);
    }, [activeTab]);

    useEffect(() => {
        const scrollFunc = (id: string, k: number) => {
            const target = document.querySelector(id) as HTMLDivElement;
            if (target) {
                AniContainer.create({
                    triggerElement: id,
                    triggerHook: 1,
                    offset: '80%',
                    duration: target?.offsetHeight,
                    onEnter: () => setActiveTab(k),
                });
            }
        };
        const ids: string[] = ['#community-page-B', '#community-page-C', '#community-page-D', '#community-page-E'];
        ids.forEach((id: string, k: number) => scrollFunc(id, k));
    }, []);

    return (
        <div className={`community-page-fix-tab ${css['community-page-fix-tab']}`}>
            <div className="tabs-wrapper">
                <ul className="tabs-box" onTouchStart={onTouchStart} onTouchMove={onTouchMove}>
                    {tabs?.map((tab: any, k: number) => (
                        <a className={`tab ${activeTab === k ? 'active' : ''}`} href={tab?.id} key={tab?.id} onClick={() => handleClickTab(tab?.key)}>
                            {tab?.text}
                        </a>
                    ))}
                </ul>
            </div>
        </div>
    );
}
